import React from 'react';
import { motion } from 'framer-motion';
import { IMAGES } from '../constants/images';
import { AmbientLight } from './AmbientLight';
import { ScrollBacklight } from './ScrollBacklight';
import { useLanguage } from '../context/LanguageContext';
const IMGS = [IMAGES.tablescape, IMAGES.trio, IMAGES.openBox];
export function Instagram() {
  const {
    t
  } = useLanguage();
  return <section className="relative overflow-hidden py-32 lg:py-48 bg-texture-dark text-cream" data-id="element-216" data-mp="1y2vdo8mz9bp3">
      <AmbientLight variant="corner" data-id="element-217" data-mp="1y4po2t0mhlex" />
      <div className="relative z-10 max-w-[1400px] mx-auto px-8 lg:px-14" data-id="element-218" data-mp="1t3igov2e6o8s">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 1
      }} className="grid lg:grid-cols-12 gap-10 items-end mb-20 lg:mb-28" data-id="element-219" data-mp="1ocsd9ndj0vgq">
          <div className="lg:col-span-8" data-id="element-220" data-mp="16ahyhge9rfqz">
            <div className="flex items-center gap-3 text-caramel text-[10px] tracking-[0.4em] uppercase mb-10" data-id="element-221" data-mp="16bt9o1a1nps4">
              <span className="w-10 h-px bg-caramel/40" data-id="element-222" data-mp="1bc75mkydf99s" />
              {t.instagram.eyebrow}
            </div>
            <h2 className="font-serif text-5xl sm:text-6xl lg:text-7xl text-cream leading-[0.95] tracking-[-0.02em] font-light" data-id="element-223" data-mp="wjdpcxb9yp42">
              {t.instagram.title1}
              <br data-id="element-224" data-mp="niyv38gc1zof" />
              <span className="italic font-extralight" data-id="element-225" data-mp="nmmp08powo3o">
                {t.instagram.title2}
              </span>
            </h2>
          </div>
          <div className="lg:col-span-4 lg:text-right" data-id="element-226" data-mp="dn5kvvq36i9t">
            <a href="https://instagram.com/tartahtx" target="_blank" rel="noreferrer" className="group inline-flex items-center gap-4 text-[11px] tracking-[0.3em] uppercase text-cream" data-id="element-227" data-mp="dop15mbqstbl">
              <span className="relative pb-1" data-id="element-228" data-mp="2cyf2aiap5bbo">
                {t.instagram.cta}
                <span className="absolute bottom-0 left-0 right-0 h-px bg-cream group-hover:bg-caramel transition-colors duration-500" data-id="element-229" data-mp="2bikrt5c7oql6" />
              </span>
              <span className="w-10 h-px bg-cream group-hover:bg-caramel group-hover:w-14 transition-all duration-500" data-id="element-230" data-mp="26laqosfgmqhi" />
            </a>
          </div>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-10" data-id="element-231" data-mp="1wmlad437pe3d">
          {t.instagram.posts.map((label, i) => <motion.a key={i} href="https://instagram.com/tartahtx" target="_blank" rel="noreferrer" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.9,
          delay: i * 0.12
        }} className="group block" data-id="element-232" data-mp="2u80r5pc5ud00" data-mpi={i}>
              <div className="relative" data-id="element-233" data-mp="3gjahurf1pan7">
                <ScrollBacklight tone="caramel" data-id="element-234" data-mp="3ki194hwtxy2e" />
                <div className="relative aspect-[4/5] overflow-hidden bg-espresso" data-id="element-235" data-mp="3kkvt68bxlgva">
                  <img src={IMGS[i]} alt={`TARTA Basque cheesecake in Houston — ${label}`} className="w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-[1.05]" data-id="element-236" data-mp="3pgb7t2hrjgsr" />
                </div>
              </div>
              <div className="mt-5 flex items-baseline justify-between text-[10px] tracking-[0.3em] uppercase" data-id="element-237" data-mp="7a6hwlkzb3xf">
                <span className="font-serif text-caramel" data-id="element-238" data-mp="c5c6js5rmwp7">0{i + 1}</span>
                <span className="text-cream/50 group-hover:text-cream transition-colors duration-500" data-id="element-239" data-mp="h1ax9mekgqss">
                  {label}
                </span>
              </div>
            </motion.a>)}
        </div>
      </div>
    </section>;
}